import { IconComponentModule } from '@b2b/common/components/icon';
import angular from 'angular';

class AutorenewRetailPriceController {
  static $inject = ['$element'];

  constructor(private $element: JQuery) {}

  $onInit() {
    this.$element.addClass('acme-autorenew-retail-price');
  }
}

export const AutorenewRetailPriceComponentModule = angular
  .module('acme.autorenew.component.autorenew-retail-price', [IconComponentModule])
  .component('acmeAutorenewRetailPrice', {
    templateUrl: 'modules/autorenew/components/autorenew-retail-price/autorenew-retail-price.component.tpl.html',
    controller: AutorenewRetailPriceController,
    bindings: {
      retailPrice: '<',
    },
  }).name;
